const routes =  {
  mainPagePath: () => ('/'),
  loginPagePath: () => ('/login'),
};

export default routes;
